import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";

const PreArrivalSupportSection = () => {
  const supportItems = [
    {
      icon: "fa fa-map-signs",
      title: "City & Travel Guidance",
      items: [
        "Directions from Airport / Railway Station to Venue",
        "Google Maps location shared above for easy navigation",
        "List of nearby affordable hotels",
      ],
      iconColor: "#2196F3",
    },
    {
      icon: "fa fa-phone",
      title: "Emergency Assistance",
      items: [
        "24×7 Emergency Contact: +91 9289009709",
        "Email: ea@jsa.net.in",
      ],
      iconColor: "#F2BC00",
    },
    {
      icon: "fa fa-whatsapp",
      title: "Personalised WhatsApp Welcome",
      items: [
        "Automated welcome message",
        "Complete event schedule",
        "Entry & check-in instructions",
        '"Ask Me Anything" digital support link for instant help',
      ],
      iconColor: "#25D366",
    },
  ];

  return (
    <section className="section-padding" style={{ background: "#252686" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <SectionTitle
              title="Pre-Arrival Digital Support"
              titleStyle={{ color: "#FFFFFF" }}
              paragarap="We ensure you're fully guided even before you start your journey."
              paragraphStyle={{ color: "#FFFFFF" }}
            />
          </div>
        </div>
        <div className="row justify-content-center">
          {supportItems.map((item, idx) => (
            <div key={idx} className="col col-xl-4 col-lg-6 col-md-6 col-12" style={{ marginBottom: 30, display: "flex" }}>
              <div
                className="what-you-get-card"
                style={{
                  width: "100%",
                  background: "rgba(255,255,255,0.08)",
                  borderRadius: 16,
                  border: "1px solid rgba(255,255,255,0.2)",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                  padding: 24,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  textAlign: "left",
                  gap: 12,
                  transition: "transform .2s ease, box-shadow .2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow = "0 12px 26px rgba(0,0,0,0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.15)";
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                  <div
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 12,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: item.iconColor,
                      color: "#fff",
                      boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)",
                    }}
                  >
                    <i className={item.icon} style={{ fontSize: 20 }} />
                  </div>
                  <h3
                    style={{
                      fontSize: 18,
                      fontWeight: 800,
                      color: "#FFFFFF",
                      margin: 0,
                    }}
                  >
                    {item.title}
                  </h3>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: 1,
                    background: "rgba(255,255,255,0.2)",
                    margin: "6px 0 4px",
                  }}
                />
                <ul style={{ listStyle: "none", padding: 0, margin: 0, width: "100%" }}>
                  {item.items.map((listItem, i) => (
                    <li
                      key={i}
                      style={{
                        marginBottom: "10px",
                        fontSize: "15px",
                        lineHeight: 1.7,
                        color: "#FFFFFF",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "10px",
                      }}
                    >
                      <i
                        className="fa fa-check-circle"
                        style={{
                          fontSize: "16px",
                          color: item.iconColor,
                          marginTop: "2px",
                          flexShrink: 0,
                        }}
                      ></i>
                      <span>{listItem}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PreArrivalSupportSection;

